import { render, staticRenderFns } from "./change-status.vue?vue&type=template&id=3cc6fb3a"
import script from "./change-status.vue?vue&type=script&lang=js"
export * from "./change-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports